import { render } from "./PenawaranPage.vue?vue&type=template&id=5635bd2c&scoped=true"
import script from "./PenawaranPage.vue?vue&type=script&lang=js"
export * from "./PenawaranPage.vue?vue&type=script&lang=js"

import "./PenawaranPage.vue?vue&type=style&index=0&id=5635bd2c&lang=css&scoped=true"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5635bd2c"]])

export default __exports__